import type { FC } from 'react';
import { useSelector } from 'react-redux';

import type { AppState } from 'index';

import { ModalNamesEnum } from '@Modules/app/constants';
import { selectOfferCard, selectOffersContact } from '@Modules/offers/selectors';

import { PhoneModal } from '@Atomic/organisms/PhoneModal';

export const OfferPhoneModal: FC = () => {
  const offerCard = useSelector(selectOfferCard);
  const seller = offerCard?.card?.seller;
  const contact = useSelector(selectOffersContact);
  const isVisible = useSelector(
    (state: AppState) => state.app.modal?.name === ModalNamesEnum.CONTACTS
  );

  if (!isVisible || !seller || !contact?.phone) {
    return null;
  }

  return <PhoneModal visible phone={contact.phone} seller={seller} />;
};
